// @flow
import React, { Fragment } from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Bed from "elevate-ui-icons/Bed";
import Bath from "elevate-ui-icons/Bath";
import SqFt from "elevate-ui-icons/SqFt";
import { withGlobalContext } from "../common/GlobalContext";
import type { CompliantListingType } from "flow/types";

type Props = {
  classes: Object,
  className: string,
  compliance: Object,
  isListingCard: boolean,
  listing: CompliantListingType,
};

function renderBaths({ listing, classes }) {
  const bathroomsFull = Number(listing.bathroomsFull);
  const halfBaths = Number(listing.halfBaths);
  const baths = Number(listing.baths);

  let display;
  // If we have 3 Full 0 Half, just show 3 Baths
  // If we have 1 Full 1 Half and we see 3 Baths, use 3 Baths, something is wrong with the MLS Data
  if (bathroomsFull && halfBaths && halfBaths + bathroomsFull >= baths) {
    display = (
      <Fragment>
        <span className={classes.count}>{bathroomsFull}</span>
        <span className={classes.label}>Full</span>
        <span className={classes.count}>{halfBaths}</span>
        <span className={classes.label}>Half Baths</span>
      </Fragment>
    );
  } else if (Number(baths)) {
    display = (
      <Fragment>
        <span className={classes.count}>{baths}</span>
        <span className={classes.label}>
          {Number(baths) === 1 ? "Bath" : "Baths"}
        </span>
      </Fragment>
    );
  }

  return display ? (
    <div className={classNames(classes.detail, classes.iconSpacing)}>
      <Bath size={24} color="#888f96" />
      {display}
    </div>
  ) : null;
}

const ListingCallouts = ({
  classes,
  className,
  compliance,
  isListingCard,
  listing,
}: Props) => {
  switch (listing.type) {
    case "Land":
      let data = listing.squareFootageFormatted;
      let label = "Sq Ft";
      if (
        compliance &&
        compliance.listingResults &&
        compliance.listingResults.showAcresInsteadOfLotSize
      ) {
        data = listing.acres;
        label = "Acres";
      }

      if (data === "-") {
        return null;
      }

      return (
        <div className={classNames(classes.root, className)}>
          <div className={classNames(classes.detail, classes.iconSpacing)}>
            <SqFt color="#888f96" />
            <span className={classes.count}>{data}</span>
            <span className={classes.label}>{label}</span>
          </div>
        </div>
      );
    default:
      return listing.bedrooms || listing.baths ? (
        <div className={classNames(classes.root, className)}>
          {listing.bedrooms ? (
            <div className={classes.detail}>
              <Bed color="#888f96" className={classes.icon} />
              <span className={classes.count}>{listing.bedrooms}</span>
              <span className={classes.label}>Beds</span>
            </div>
          ) : null}
          {renderBaths({ listing, classes })}
          {!isListingCard &&
          listing.livingAreaFormatted &&
          listing.livingAreaFormatted !== "-" ? (
            <div className={classNames(classes.detail, classes.iconSpacing)}>
              <SqFt color="#888f96" />
              <span className={classes.count}>
                {listing.livingAreaFormatted}
              </span>
              <span className={classes.label}>Sq Ft</span>
            </div>
          ) : null}
        </div>
      ) : null;
  }
};
export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    width: "100%",
    padding: (props) => (props.isListingCard ? "0px 8px" : "10px 0px"),
  },
  detail: {
    display: "flex",
    alignItems: "center",
    padding: "6px",
  },
  iconSpacing: {
    marginLeft: (props) => (props.isListingCard ? "0px" : "10px"),
  },
  count: {
    fontSize: (props) => (props.isListingCard ? "16px" : "18px"),
    lineHeight: "1",
    fontWeight: "600",
    color: theme.colors.gray700,
    marginLeft: "6px",
  },
  label: {
    fontSize: (props) => (props.isListingCard ? "14px" : "16px"),
    lineHeight: "1",
    color: theme.colors.gray600,
    marginLeft: "4px",
  },
}))(withGlobalContext(ListingCallouts));
